import psl_ui from './libs/psl_ui.js';

const func = () => {
	if(window.pano2vrSkin) return 'assets/extras/games/';
	return '';
}

psl_ui.helpers.add('path',func);

export default func;
